<template>
    <div class="export-detail-edit" >
        <el-form :model="dataForm" ref="dataForm" label-position="top"  class="dataForm" :rules="rules" scroll-to-error>
            <div class="biz-type">
                <span>
                发票类型：6% 服务费发票
                </span>
            </div>
            <div class="title-1">
                收发货信息
            </div>
            <div class="consignee clearfix">
                <div class="logo">
                    <el-popover
                        placement="top-end"
                        popper-class="form-pop"
                        :width="300"
                        trigger="hover"
                        content=""
                    >
                        <template #reference>
                            <ab-svg name="gnj"></ab-svg>
                        </template>
                    </el-popover>
                    <div class="step-line" :style="{'height': stepline()}"></div>
                    <div class='normal'></div>
                    <div class="jiantou">
                        <ab-svg name="jiantou"></ab-svg>
                    </div>
                    <el-popover
                        placement="top-end"
                        popper-class="form-pop"
                        :width="300"
                        trigger="hover"
                        content=""
                    >
                        <template #reference>
                            <ab-svg name="jws"></ab-svg>
                        </template>
                    </el-popover>
                </div>
                <div class="content">
                    <el-row :gutter="20">
                        <el-col :span="24" v-if="['01','04'].includes(dataForm.incomingMethod)">
                            <el-form-item  prop="incomingCompany" style="margin-bottom:20px">
                                <ab-select2
                                    url="/bas/client/basAddress/list"
                                    descKey="companyName"
                                    v-model="dataForm.incomingCompany"
                                    label="发货公司"
                                    inputKey="companyName"
                                    :urlData="{data: {addressType: '04', bizTypeGroup: '02'}, pageSize: 10, pageNum: 1}"
                                    required
                                    @handleSelect="handleCompany"
                                    @handlerAdd="handleAddCompany"
                                >
                                <template v-slot:content="scope">
                                    <div class="delivery-company" v-if="scope.item.companyName">
                                        <div class="company">{{scope.item.companyName}} <span class="is-default" v-if="scope.item.isDefault">默认</span></div>
                                        <div class="address">
                                            <ab-svg name="dingwei"></ab-svg>
                                            {{ scope.item.addressIdsName }} / {{ scope.item.linkMan }} / {{ scope.item.linkPhone }}</div>
                                    </div>
                                    <div v-else style="color:#999999;text-align: center;">
                                        暂无数据，可点击左侧”+“进行新增
                                    </div>
                                </template>
                                </ab-select2>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="dataForm.incomingCompany">
                            <div class="incoming-div">
                                <ab-svg name="dingwei2"></ab-svg>
                                {{dataForm.addressIdsName}} <span v-if="dataForm.incomingLinkman">/ {{dataForm.incomingLinkman}}</span> <span v-if="dataForm.incomingContactNumber">/ {{dataForm.incomingContactNumber}}</span>
                                <ab-svg style="width: 16px; height: 16px; color: #000; cursor: pointer; margin: 2px 0 0 5px;vertical-align: top;" @click="editAddress" name="edit"></ab-svg>
                            </div>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item label="交货方式" prop="incomingMethod">
                                <el-select :disabled="isEdit" @change="checkedRadio" v-model="dataForm.incomingMethod" size="mini">
                                    <el-option
                                    v-for="(item, index) in [{desc: '供应链提货', value: '01'}, {desc: '工厂送货', value: '02'}, {desc: '快递送货', value: '03'}, {desc: '客户负责物流', value: '04'}]" 
                                    :key="index"
                                    :label="item.desc"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <template v-if="dataForm.incomingMethod == '01'">
                            <el-col :span="8" v-if="dataForm.incomingMethod == '01'">
                                <el-form-item label="已通知提货"  prop="incomingIsNotice">
                                    <el-select size="mini" :disabled="isEdit" @change="changeLocatin" v-model="dataForm.incomingIsNotice" placeholder="请选择">
                                        <el-option
                                        v-for="item in [{value: 1, desc: '是'}, {value: 0, desc: '否'}]"
                                        :key="item.value"
                                        :label="item.desc"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" v-if="dataForm.incomingIsNotice">
                                <el-form-item label="关联提货单号"  prop="incomingNumber" :rules="[{ required: dataForm.incomingIsNotice, message: '请输入关联提货单号', trigger: 'blur'}]">
                                    <ab-select 
                                        url="/tms/deliveryNotice/list"
                                        inputKey="number"
                                        descKey="number"
                                        :disabled="isEdit || !dataForm.incomingIsNotice"
                                        @handleSelect="handleIncomingNumber"
                                        v-model="dataForm.incomingNumber"
                                        :urlData="{data: {number: dataForm.incomingNumber},  pageSize: 10, pageNum: 1}"
                                        >
                                    </ab-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="要求提货时间"  prop="incomingTime" >
                                    <ab-dateTimePick :disabled="isEdit" v-model="dataForm.incomingTime" size="mini" ></ab-dateTimePick>
                                </el-form-item>
                            </el-col>
                            <el-col :span="dataForm.incomingIsNotice ? 16 : 24">
                                <el-form-item label="备注" prop="incomingRemark">
                                    <el-input size="mini" maxLength='200' :disabled="isEdit" v-model="dataForm.incomingRemark" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-col>
                        </template>
                        <!--工厂送货-->
                        <template v-if="dataForm.incomingMethod == '02'">
                            <el-col :span="8" >
                                <el-form-item label="预计送货时间"  prop="incomingTime" >
                                    <ab-dateTimePick :disabled="isEdit" v-model="dataForm.incomingTime" size="mini" ></ab-dateTimePick>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="备注" prop="incomingRemark">
                                    <el-input size="mini" maxLength='200' :disabled="isEdit" v-model="dataForm.incomingRemark" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <div class="incoming-div">
                                <ab-svg name="dingwei2"></ab-svg>
                                一咻仓库地址：东莞市凤岗镇京东智谷10栋701-702       联系人及电话：陈刚  +86-18503021572
                                </div>
                            </el-col>
                        </template>
                        <!--快递送货-->
                        <template v-if="dataForm.incomingMethod == '03'">
                            <el-col :span="8">
                                <el-form-item label="快递号" prop="incomingFastMailNumber">
                                    <el-input size="mini" maxLength='200' :disabled="isEdit" v-model="dataForm.incomingFastMailNumber" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="快递公司" prop="incomingFastMailCompanyContent">
                                    <el-input size="mini" maxLength='200' :disabled="isEdit" v-model="dataForm.incomingFastMailCompanyContent" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" >
                                <el-form-item label="预计到货时间" >
                                    <ab-dateTimePick :disabled="isEdit" :gutter="0" v-model="dataForm.incomingTime" size="mini" ></ab-dateTimePick>
                                </el-form-item>
                            </el-col>
                            
                            <el-col :span="16">
                                <el-form-item label="备注" prop="incomingRemark">
                                    <el-input size="mini" maxLength='200' :disabled="isEdit" v-model="dataForm.incomingRemark" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <div class="incoming-div">
                                <ab-svg name="dingwei2"></ab-svg>
                                一咻仓库地址：东莞市凤岗镇京东智谷10栋701-702       联系人及电话：陈刚  +86-18503021572
                                </div>
                            </el-col>
                        </template>
                        <!--客户负责物流-->
                        <template v-if="dataForm.incomingMethod == '04'">
                            <el-col :span="8" >
                                <el-form-item label="预计货好时间"  prop="incomingTime" >
                                    <ab-dateTimePick :disabled="isEdit" v-model="dataForm.incomingTime" size="mini" ></ab-dateTimePick>
                                </el-form-item>
                            </el-col>
                            
                          
                            <el-col :span="24">
                                <el-form-item label="备注" prop="incomingRemark">
                                    <el-input size="mini" maxLength='200' :disabled="isEdit" v-model="dataForm.incomingRemark" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-col>
                        </template>
                    </el-row>

                    <domesticDelivery 
                        :dataForm="dataForm"
                        ref="domesticDelivery"
                        sourceType="out"
                        @getDefaultAddress="getDefaultAddress"
                        :typeList="typeList"
                        @setUploadParams="$emit('setUploadParams')"
                    ></domesticDelivery>
                </div>
            </div>
            <div class="cargoInfo">
               
               <orderDetail 
                   :packingTypeList="typeList.packingTypeList"
                   sourceType="out"
                   :dataForm="dataForm"
                   :deleteArr="deleteArr"
                   @aiSuccess="$emit('aiSuccess')"
                   @save="autoSave"
                   ref="ordersDetail"
               ></orderDetail>
           
              
           </div>
            
        </el-form>
        <ab-handlerAds :dialog="addressData"  ref="handlerAds" @change="handlerAddress" @handlerChange="submitLinkman"></ab-handlerAds>
        <el-dialog title="修改地址信息" width="718px" v-model="editDialog.show" :before-close="editHandleClose" :close-on-click-modal='false' class="add-address-dialog">
            <el-form :model="editFormSearch" :rules="editRules" ref="editFormSearch" label-position="top">
                <el-row :gutter="30">
                
                <el-col :span="12">
                    <el-form-item label="联系人" prop="linkMan">
                    <el-input   maxLength='50' placeholder="联系人" v-model="editFormSearch.linkMan" ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="联系电话" prop="linkPhone">
                    <el-input   maxLength='20' placeholder="联系电话" v-model="editFormSearch.linkPhone" ></el-input>
                    </el-form-item>
                </el-col>
                

                <el-col :span="12">
                    <el-form-item label="国家/省/市/区" prop="address">
                    <ab-address v-model="editFormSearch.addressIdsDesc" @handleSelect="changeAddressDesc"></ab-address>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="详细地址" prop="addressContent">
                    <el-input   v-model="editFormSearch.addressContent"  maxLength="250" placeholder="详细地址"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="公司名称" prop="companyName">
                        <el-input  v-model="editFormSearch.companyName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="默认地址" prop="isDefault">
                        <el-select  placeholder v-model="editFormSearch.isDefault">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div  class="dialog-footer">
                    <el-button type="primary" @click="handlerIncomAddressSave" :loading="editDialog.isloading">确 定</el-button>
                    <el-button @click="editDialog.show = false">取 消</el-button>
                </div>
            </template>
    </el-dialog>
    </div>
</template>

<script>
import domesticDelivery from './domestic-delivery.vue'
import orderDetail from './orders-detail.vue'
export default {
    components: {
        domesticDelivery,
        orderDetail
    },
    data ()  {
        return {
            rules: {
                incomingMethod: [{ required: true, message: '请选择交货方式', trigger: 'change'}],
                incomingIsNotice: [{ required: true, message: '请选择已通知提货', trigger: 'change'}],
                incomingTime: [{ required: true, message: '请选择时间', trigger: 'change'}],
                incomingAddress: [{ required: true, message: '请选择提货地址', trigger: 'change'}],
                incomingCompany: [{ required: true, message: '请输入发货公司', trigger: 'blur'}],
                incomingLinkman: [{ required: true, message: '请输入联系人', trigger: 'blur'}],
                incomingContactNumber: [{ required: true, message: '请输入联系电话', trigger: 'blur'}],
                incomingFastMailNumber: [{ required: true, message: '请输入快递号', trigger: 'blur'}],
                incomingFastMailCompanyContent: [{ required: true, message: '请输入快递公司', trigger: 'blur'}],
                incomingPayType: [{ required: true, message: '请选择付费方式', trigger: 'change'}],
                incomingAreaId: [{ required: false, message: '请选择区域', trigger: 'change'}]
            },
            addressData: {
                id: '',
                type: '02',//业务类型 01 进口，02 出口
                addressExplain: '3',//地址说明
                addressType: '04',//地址类型
                companyName: '',
                isEnabled: true,
                show: false
            },
            editFormSearch: {},
            editDialog: {
                show: false,
                id: '',
                isloading: false
            },
            editRules: {
                linkMan: [
                    {required: true, message: '联系人不能为空', trigger: ['blur', 'change']}
                ],
                linkPhone: [
                    {required: true, message: '联系电话不能为空', trigger: ['blur', 'change']},
                    { validator: (rule, value, callback) => {
                      if (/[\u4E00-\u9FA5]/g.test(value)) {
                          callback(new Error('电话号码不能输入中文!'))
                        } else if (value.length > 200){
                          callback(new Error('最大支持200位字符长度'))
                        } else {
                          callback()
                        }
                    }, trigger: ['blur', 'change'] }
                ],
                addressIdsDesc: [
                    {required: true, message: '地址不能为空', trigger: ['blur', 'change']}
                ],
                addressContent: [
                    {required: true, message: '详细地址不能为空', trigger: ['blur', 'change']}
                ],
                addressExplain: [
                    {required: true, message: '地址说明不能为空', trigger: ['blur', 'change']}
                ],
                companyName: [
                    {required: true, message: '公司名称不能为空', trigger: ['blur', 'change']}
                ],
                isDefault: [
                    {required: true, message: '默认地址不能为空', trigger: ['blur', 'change']}
                ],
            },
        }
    },
    props: {
        isDisabled: {
            type: Boolean,
            default: false
        },
        dataForm: {
            type: Object
        },
        status: {
            type: Boolean,
            default: false
        },
        bizType: {
            type: Array,
            default: []
        },
        typeList: {
            type: Object,
            default: {}
        },
        deleteArr: {
            type: Array,
            default: []
        }
    },
    methods: {
        stepline () {
            let str = '40px'
            if (this.dataForm.incomingMethod == '01' || this.dataForm.incomingMethod == '04') {
                str = '240px'
                if (this.dataForm.incomingCompany) {
                    str = '290px'
                }
            }
            if (this.dataForm.incomingMethod == '02') {
                str = '160px'
            }
            if (this.dataForm.incomingMethod == '03') {
                str = '220px'
            }
            return str
        },
        handleCompany (item) {
            console.log(item)
            this.dataForm.incomingAddress = item.addressContent
            this.dataForm.incomingAreaId = item.addressIdsDesc
            this.dataForm.incomingLinkman = item.linkMan
            this.dataForm.incomingContactNumber = item.linkPhone
            this.dataForm.incomingCompany = item.companyName
            this.dataForm.addressIdsName = item.addressIdsName
        },
        handleAddCompany () {
            this.addressData.companyName = this.dataForm.supplierName
            this.addressData.sourceBillId = this.dataForm.supplierId
            this.addressData.sourceBillType = 'Supplier'
            this.addressData.isDefaultAdd = true
            this.addressData.show = true
        },
        handlerAddress (item) {
            this.dataForm.incomingAreaId = item.address
            this.dataForm.incomingAddress = item.addressContent
            this.dataForm.incomingLinkman = item.linkMan
            this.dataForm.incomingContactNumber = item.linkPhone
            this.dataForm.incomingCompany = item.companyName
            this.dataForm.addressIdsName = item.areaDesc.replace(' ', '') + '-' + item.addressContent
        },
        submitLinkman (item) {
            this.$refs.handlerAds.isloading = true
            this.$post('/bas/client/basSupplier/checkSupplierLinkmanEntry', {parentId: this.dataForm.supplierId, linkAddress: item.addressContent}).then(res => {
                if (res.data.code === 'C0000') {
                    this.addressData.isReset = false
                    this.$refs.handlerAds.handlerSave()
                    let obj = res.data.result
                    this.$post('/bas/client/basAddress/add', {
                        tempBillId: obj ? obj.id : '',
                        addressContent: item.addressContent,
                        addressIds: item.address.join(','),
                        bizTypeGroup: item.bizTypeGroup, //业务类型
                        addressType: item.addressType,
                        companyName: item.companyName,
                        isDefault: item.isDefault,
                        isEnabled: 1,
                        linkMan: item.linkMan,
                        linkPhone: item.linkPhone,
                        addressDescription: item.addressExplain, //地址说明
                    }).then(res => {
                        if (res.data.code === 'C0000') {
                            this.dataForm.incomingAreaId = item.address
                            this.dataForm.incomingAddress = item.addressContent
                            this.dataForm.incomingLinkman = item.linkMan
                            this.dataForm.incomingContactNumber = item.linkPhone
                            this.dataForm.incomingCompany = item.companyName
                            this.handlerAddress(item)
                            this.$refs.handlerAds.isloading = false
                            this.$refs.handlerAds.handleClose()
                        }
                    }).finally(() =>{
                        if (this.$refs.handlerAds) {
                            this.$refs.handlerAds.isloading = false
                        }
                    })
                }else{
                    this.addressData.isReset = true
                }
            })
        },
        checkedRadio (str) {
            this.resetData()
            if ((this.dataForm.incomingMethod === '01' || this.dataForm.incomingMethod === '04') && this.dataForm.supplierId) {
                this.getDefaultAddress()
            }
        },
        getDefaultAddress () {
            let data = {data: {addressType:"04", bizTypeGroup:"02", isDefault: 1}, pageNum: 1, pageSize: 10}
            this.$post('/bas/client/basAddress/list', data).then(res => {
                if (res.data.code === 'C0000') {
                    let item = res.data.result.list[0]
                    if (item) {
                        this.dataForm.incomingAddress = item ? item.addressContent : ''
                        this.dataForm.incomingAreaId = item ? item.addressIdsDesc : []
                        this.dataForm.incomingLinkman = item ? item.linkMan : ''
                        this.dataForm.incomingContactNumber = item ? item.linkPhone : ''
                        this.dataForm.incomingCompany = item ? item.companyName : ''
                        this.dataForm.addressIdsName = item ? item.addressIdsName : ''
                    }
                }
            })
        },
        resetData () {
            this.dataForm.incomingIsNotice = ''
            this.dataForm.incomingNumber = ''
            this.dataForm.incomingTime = ''
            this.dataForm.incomingAddress = ''
            this.dataForm.incomingCompany = ''
            this.dataForm.incomingLinkman = ''
            this.dataForm.incomingContactNumber = ''
            this.dataForm.incomingRemark = ''
            this.dataForm.incomingFastMailNumber = ''
            this.dataForm.incomingFastMailCompanyContent = ''
            this.dataForm.incomingPayType = ''
        },
        changeLocatin () {
           
            this.dataForm.incomingNumber = ''
            
        },
        handleIncomingNumber (item) {
                if (item.id) {
                let addressIds1 = item.addressIds
                let addressIds = []
                if(typeof item.addressIds === 'string') {
                    addressIds1 = item.addressIds.split(',')
                    addressIds1.forEach(ele=>{
                        addressIds.push(ele)
                    })
                }
                this.dataForm.incomingAddress = item.addressContent
                this.dataForm.incomingTime = item.deliveryTime
                this.dataForm.incomingAreaId = addressIds
                this.dataForm.incomingLinkman = item.linkMan
                this.dataForm.incomingContactNumber = item.linkPhone
                this.dataForm.incomingCompany = item.companyName
            } else {
                this.dataForm.incomingAddress = ''
                this.dataForm.incomingTime = ''
                this.dataForm.incomingAreaId = []
                this.dataForm.incomingLinkman = ''
                this.dataForm.incomingContactNumber = ''
                this.dataForm.incomingCompany = ''
            }
            this.$refs.dataForm.validateField('incomingNumber')
        },
        autoSave() {
            this.$emit('autoSave')
        },
        changeProtocol (state) {
            if (state != 'init') {
                this.dataForm.creditRequirement = ''
            }
            this.getProtocol(this.dataForm.bizType, this.dataForm.trusteeId, state)
        },
        getProtocol (bizType, trusteeId, state) {
            this.$post('/bas/client/servProtocol/list', {
                entrustId: this.dataForm.principalId,
                isEnable: 1,
                type: bizType,
                trusteeId: trusteeId,
                queryDate: this.dataForm.bizDate,
                typeList: ['03', '04'],
                status: '03'
            }).then(res => {
                if (res.data && res.data.code === 'C0000') {
                    let data = res.data.result
                    if (res.data.result.length === 1) {
                        this.setProtocol(res.data.result[0])
                    } else if (res.data.result.length > 1){
                        this.$confirm('您存在多个合作主体或多个协议，请与商务联系，指定1个?', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'error'
                        }).then(() => {
                            this.$emit('collback')
                        })
                    }

                }
            })
        },
        setProtocol (protocol) {
            this.dataForm.salesManId = protocol.salesmanId
            this.dataForm.salesManName = protocol.salesManName
            this.dataForm.marginRatio = protocol.marginLevel
            this.dataForm.isGoodsControlled = protocol.cargoControl
            this.dataForm.protocolName = protocol.name
            this.dataForm.protocolId = protocol.id
            this.dataForm.businessManName = protocol.businessManIdDesc
            this.dataForm.businessManId = protocol.businessManId
            this.dataForm.insurance = protocol.insurance
            this.dataForm.riskControlId = protocol.riskControlId
            //cushionMoney taxPayment
            
            this.options = []
            if (protocol.cushionMoney && protocol.taxPayment) { //协议中带出垫货款，和垫税款
                this.options = this.cqList
                
            } 
            this.$emit('isChangeLimit', protocol)
        },
        editAddress () {
            this.$post('/bas/client/basAddress/list', {data: {addressType: '04', bizTypeGroup: '02',  addressContent: this.dataForm.incomingAddress}, pageSize: 10, pageNum: 1}).then(({data}) => {
                if(data.code === 'C0000') {
                    this.editFormSearch = data.result && data.result.list && data.result.list.length ? data.result.list[0] : {}
                    if(!data.result.list || !data.result.list.length) {
                        this.$message.error('地址已被删除，请重新选择或前往【我的地址】维护！')
                        return
                    }
                    this.editDialog.show = true
                }
            })
        },
        editHandleClose () {
            this.editDialog.show = false
        },
        handlerIncomAddressSave() {
            this.editDialog.isloading = true
            this.editFormSearch.addressIds = this.editFormSearch.addressIdsDesc.join(',')
            let url = '/bas/client/basAddress/mod'
            if (this.sourceType == 'export') {
                url = '/bas/client/basCustomer/submitLinkman'
            }
            this.$post(url, this.editFormSearch).then(({data}) => {
                if(data.code === 'C0000') {
                    this.$message({
                        type: 'success',
                        message: data.message,
                        offset: 380,
                        grouping: true,
                    })
                    this.editDialog.show = false
                    this.dataForm.addressIdsName = this.editFormSearch.addressIdsName.split('-')[0] + '-' + this.editFormSearch.addressContent
                    this.dataForm.incomingAddress = this.editFormSearch.addressContent
                    this.dataForm.incomingLinkman = this.editFormSearch.linkMan
                    this.dataForm.incomingContactNumber = this.editFormSearch.linkPhone
                    this.dataForm.incomingCompany = this.editFormSearch.companyName
                }
            }).finally(() => {
                this.editDialog.isloading = false
            })
        }
    }
}
</script>

<style lang="scss">
.export-detail-edit {
    .incoming-div {
        margin-bottom: 38px;
        .icon-svg {
            width: 11px;
            height: 16px;
            vertical-align: middle;
        }
    }
   
    padding-bottom: 30px;
    .el-form-item {
        margin-bottom: 40px;
    }
    // .form-item-a {
    //     .el-form-item {
    //         margin-bottom: 30px;
    //     }
    // }
    text-align: left;
    border-top: 1px solid #F0F2F5;
    color: #000000;
    .el-table th.must>.cell:after {
	    content: ' *';
	    color: #ff1818;
    }
    .el-form-item__label{
        color: #000000;
        font-size: 14px;
    }
    .biz-type {
        height: 35px;
        line-height: 35px;
        background-color: #F2F7FF;
        border-radius: 0 0 8px 8px;
        width: 270px;
        text-align: center;
        cursor: pointer;
        .icon-svg {
            vertical-align: middle;
            width: 14px;
            height: 14px;
        }
    }
    .tax-limit {
        margin-top: 30px;
        height: 80px;
        width: 453px;
        border:2px solid #0A7CFF;
        border-radius: 15px;
        position: relative;
        display: flex;
        .limit-left {
            width: 140px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .msg-center {
            width: 250px;
            margin-top: 15px;
            text-align: left;
            padding: 0 20px;
            color:#000000;
            .number {
                font-size: 18px;
                color:#F87243;
                line-height: 1.5;
            }
            .by {
                font-size: 12px;
            }
        }
        .msg-right{
            width: 145px;
            border-left: 2px solid #eeeeee;
            margin: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #0A7CFF;
            cursor: pointer;
            .icon-svg {
                width: 25px;
                height: 25px;
                vertical-align: middle;
            }
            div {
                display: flex;
                align-items: center;
            }
            
        }
    }
    .is-taxes {
        border: 2px solid #eeeeee;
        .title {
            background-color: #eeeeee;
        }
    }
    .title-1 {
        color: #000000;
        line-height: 40px;
        font-size: 18px;
        margin: 30px 0 40px 0;
    }
    .consignee {
        position: relative;
        border-bottom: 1px solid #F0F2F5;
        .logo {
            float: left;
            width: 54px;
            .icon-svg {
                width: 54px;
                height: 74px;
            }
            .step-line {
                width: 2px;
                height: 130px;
                background: linear-gradient(to bottom, #88B2E9, #88B2E9 7.5px, transparent 7.5px, transparent);
                background-size: 100% 15px;
                margin-left: 26px;
            }
           
        }
        .content {
            float: left;
            margin-left: 40px;
            width: calc(100% - 95px);
            .supplierName{
                width: 100%;
                display: flex;
                padding: 20px 0;
                border-bottom: 1px solid #F0F2F5;
                line-height: 24px;              
                .supplier{
                    padding: 5px 12px;
                    height: 24px;
                    line-height: 14px;
                    border-radius: 4px;
                    background-color: #F0F2F5;
                    span{
                        color: #FE2424;
                    }
                }
                .icon-svg{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin: 0 10px;
                    cursor: pointer;
                }
                p{
                    font-size: 22px;
                    font-weight: bold;                    
                }
            }
            .basics-label {
                width: 100%;
                display: flex;
                padding-top: 28px;
                line-height: 60px;
                cursor: pointer;
                .icon-svg{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin: 20px 10px;
                    cursor: pointer;
                }
                p{
                    font-size: 14px;
                    // font-weight: bold;                    
                }
            }
            .receivingAddress{
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 40px;
                .el-icon{
                    vertical-align: middle;
                }
            }
        }
        .jiantou {
            height: 12px;
            text-align: center;
            .icon-svg {
                vertical-align: super;
                width: 12px;
                height: 12px;
            }
        }
        
    }
    .cargoInfo{
        padding-top: 28px;
       .title-2 {
         display: flex;
         justify-content: space-between;
         margin-bottom: 20px;
         .left{
            display: flex; 
            align-items: center;
            h3{
               font-size: 18px;
               margin-right: 25px;
               white-space: nowrap;
            }
            .text{
                font-size: 14px;
                color: #000000;
                margin-right: 10px;
                span{
                    color: #FE2424;
                    margin: 0 20px 0 3px;
                }
                i{
                    display: inline-block;
                    width: 1px;
                    height: 14px;
                    background-color:#A0A0A0 ;
                   
                }
            }
         }
        .el-form-item {
            margin-bottom:0px
        }
       }
       .el-alert{
        background-color: #FEEAE3;
        color:#F87243 ;
        span{
            font-size: 14px;
        }
           
       }
       .el-table{
        margin-top: 20px;
        .el-table__header-wrapper{
            .el-table-column--selection.is-leaf.el-table__cell{
                border-right: 0px;
            }
        }
        .el-table__body-wrapper{
            td{
                border-bottom: 1px solid #F0F2F5;
            }
           .el-table-column--selection.el-table__cell{
                border-right: 0px;
            }
            
            
           
        }

       }
       .addCargo{
        width: 100%;
        padding: 0 20px;
        height: 45px;
        margin-bottom:40px ;
        background-color: #F2F7FF;
        text-align: left;
        font-size: 14px;
        line-height: 45px;
        span {
            cursor: pointer;
        }
        .icon-svg{
            width: 24px;
            height: 24px;
            vertical-align: middle;
            cursor: pointer;
        }
       }
       .cargoMoney{
        margin-bottom: 40px;
        & > div{
            flex: 1;
            h5{
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 20px;
            }
            div{
                font-size: 30px;
                font-weight: 500;
            }
        }
       }
       .cargoRemark{
         .el-form-item{
             margin-bottom: 8px;
         }
       
         h5{
            margin-bottom: 15px;
            font-weight: 400;
            font-size: 14px;
         }
         .el-textarea{
                      
            .el-textarea__inner{               
                min-height:45px !important;
                padding-top: 11px;
            }
         }
         .alert{
            display: flex;
            .el-alert{
                margin-right: 8px;
                // max-width: 250px;
                // cursor: pointer;
                
                // .el-alert__title {
                //     overflow: hidden;
                //     white-space: nowrap;
                //     text-overflow: ellipsis;
                // }
            }
         }
       }
       .upload {
        margin: 40px 0;
          h5 {
            margin-bottom: 10px;
            font-size: 14px;
          }
          i {
            color: #ff2626;
          }
          & > div {
            display: flex;
            justify-content: space-between;
            .displaybox {
              width: 100%;
              height: 45px;
              padding: 5px;
              margin-left: 20px;
              background-color: #f0f2f5;
              border-radius: 6px;
              div {
                display: inline-block;
                padding: 0 8px 0 15px;
                margin-right: 7px;
                height: 35px;
                line-height: 35px;
                background-color: #fff;
                border-radius: 8px;
                span {
                  margin-right: 30px;
                }
                .icon-svg {
                  width: 19px;
                  height: 19px;
                  vertical-align: middle;
                  cursor: pointer;
                }
                .one {
                  margin-right: 7px;
                }
              }
            }
          }
       }
       .Coupons{
        display: flex;
        margin-bottom: 20px;
        .el-form-item{
            margin-right: 30px;
        }
       }
    }
    
    .footer {
        margin: 20px;
        text-align: center;
        
    }
    .hk-adress {
        margin-top: 36px;
        display: inline-block;
    }
    .kg-change-title {
        color: #f58507;
        background-color: #f3ffe0;
        line-height: 28px;
        margin-top: 40px;
        display: inline-block;
    }
    .edit-incoming {
        
        .el-icon {
            color: #0f7eff;
            vertical-align: middle;
            margin-right: 5px;
        }
    }
    .no-min-height {
        padding: 0 30px;
        .el-dialog__header{
            margin-right: initial;
            button{
                right: 20px;
            }
        }
        .el-autocomplete {
            width: 100%;
        }
    }
    .auto-complete-select {
        padding: 0 0 10px 0!important;
    }
}
.jw-order-edit {
    .biz-btn {
        text-align: right;
    }
    .edit-radio {
        width: 100%;
    }
    .ml-4 {
        margin: 10px
    }
}
.no-min-height {
    .el-autocomplete {
        width: 100%;
    }
}

.basics-label1 {
    .el-form-item__content {
        padding-top: 35px;
    }
}

.bizType-dialog {
    .el-dialog__footer {
        text-align: center;
        padding-top: 0;
    }
    .el-dialog__body {
        padding: 40px;
    }
    .org-item {
        width: 100%;
        height: 60px;
        border-radius: 15px;
        position: relative;
        border: 2px solid #EEEEEE;
        margin-bottom: 20px;
        cursor: pointer;
        &.isActived {
            border: 2px solid #0a7cff;
            .org-tel {
                background-color: #0a7cff;
            }
        }
        .org-tel {
            width: 37px;
            height: 36px;
            background-color: #EEEEEE;
            color: #ffffff;
            border-radius: 15px 0 15px 0;
            position: absolute;
            cursor: pointer;
            top: -2px;
            left: -2px;
            .el-icon {
                margin: 12px;
                width: 12px;
                height: 8px;
                font-weight: bold;
            }
        }
        .org-name {
            font-size: 16px;
        }
        div:last-child {
            text-align: center;
            line-height: 60px;
        }

    }

    

}
</style>